import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";
import Moment from "react-moment";
import Styles from "Styles/Styles.module.css";
import {
    showWarningAlert,
    showErrorAlert,
    showSuccessAlert,
} from "Util/Alerts";
import { GetLuckyDraw, updateLuckyDraw } from "Services/Requests";
import { DrawTypes } from "./Types";
import ImagePreview from "Components/ImagePreview";
import { MdEdit } from "react-icons/md";
import DateModalComp from "./DateModal/modal";
import { FaEye } from "react-icons/fa";

function DrawComp() {
    let TableHead = [
        "Campaign",
        "Product Name",
        "Giveaway Product",
        "Campaing Stock",
        "Sold Qty",
        "Draw Date",
        "Winner",
        "Actions",
    ];
    const navigate = useNavigate();
    const [ModalLoad, setModalLoad] = useState(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [draw, setdraw] = useState<DrawTypes[]>([]);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [DateModal, setDateModal] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState<DrawTypes>();
    const [status, setStatus] = useState(1);
    const buttons = [
        { label: "Pending", key: 1 },
        { label: "Upcoming", key: 2 },
        { label: "Completed", key: 3 },
    ];
    const GetLuckyDrawApi = async () => {
        setLoading(true);
        try {
            const response = await GetLuckyDraw(status);
            if (response?.data?.status === 1) {
                setdraw(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    };

    useEffect(() => {
        GetLuckyDrawApi();
    }, [status]);
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };
    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };
    const EditDateHandler = (Id: number, draw: DrawTypes) => {
        console.log(draw);
        /* if (status == 1) {
        } */
        setDateModal(true);
        setSelectedCampaign(draw);
    };
    const updateData = async (data: any) => {
        setLoading(true);
        setModalLoad(true);
        try {
            const response = await updateLuckyDraw(data);
            setModalLoad(false);
            setDateModal(false);
            if (response?.data?.status === 1) {
                showSuccessAlert(response?.data?.message);
                GetLuckyDrawApi();
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setModalLoad(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="image"
            />
            <DateModalComp
                ModalLoad={ModalLoad}
                details={selectedCampaign}
                isModalVisible={DateModal}
                setisModalVisible={setDateModal}
                updateData={updateData}
                status={status}
                GetLuckyDrawApi={GetLuckyDrawApi}
            />
            <header>
                <h3>Lucky Draw</h3>
            </header>
            <div className={Styles["action_tabs_orders"]}>
                {buttons.map((item) => (
                    <button
                        className={
                            status == item.key ? Styles["active_tab"] : ""
                        }
                        key={item.key}
                        onClick={() => {
                            setStatus(item.key);
                        }}>
                        {item.label}
                    </button>
                ))}
            </div>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {draw.length > 0 ? (
                                draw?.map((item) => (
                                    <tr key={item?.campaign_id}>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.image_url)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.image_url}
                                                    alt="banner"
                                                />
                                                <p>{item.campaign_code}</p>
                                            </div>
                                        </td>{" "}
                                        <td style={{ width: "12rem" }}>
                                            {item?.product_name}
                                        </td>
                                        <td>{item?.giveaway_product_name}</td>
                                        <td>{item?.campaign_stock}</td>
                                        <td>
                                            {item?.campaign_stock -
                                                item?.stock_available}
                                        </td>
                                        <td
                                            onClick={() => {
                                                EditDateHandler(
                                                    item.campaign_id,
                                                    item
                                                );
                                            }}>
                                            {item?.draw_date ? (
                                                <Moment format="DD-MM-YYYY">
                                                    {item?.draw_date}
                                                </Moment>
                                            ) : (
                                                "NA"
                                            )}{" "}
                                            {/*   {status == 1 && (
                                                <button
                                                    style={{
                                                        border: "none",
                                                        cursor: "pointer",
                                                        background: "inherit",
                                                    }}>
                                                    <MdEdit />
                                                </button>
                                            )} */}
                                            <button
                                                style={{
                                                    border: "none",
                                                    cursor: "pointer",
                                                    background: "inherit",
                                                }}>
                                                <MdEdit />
                                            </button>
                                        </td>
                                        {status == 3 ? (
                                            <td>
                                                {item.first_name}{" "}
                                                {item.last_name} ({item.winner})
                                            </td>
                                        ) : (
                                            <td>NA</td>
                                        )}
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }
                                                onClick={() =>
                                                    navigate(
                                                        `/auth/draw/${item.campaign_id}?page=1`
                                                    )
                                                }>
                                                <button>
                                                    <FaEye />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No draw Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default DrawComp;
